module.exports = __webpack_public_path__ + "img/CDN.97dd3ad.svg";